/** @format */

import React from 'react';
import DateTime from 'react-datetime';
import Moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import './date_ranage.sass';

export default class extends React.Component {
    state = {
        interval: true,
        start: Moment().utc().subtract(30, 'days'),
        end: Moment().utc().subtract(1, 'days')
    };

    handleChange = (field, date) => {
        var state = {...this.state};
        state[field] = date.utc();

        let query = state.start.format('YYYY-MM-DD') + ',' + state.end.format('YYYY-MM-DD');

        this.setState(state);

        this.props.onChange(query);
    };

    handleSelectInterval = interval => {
        this.props.onChange(interval);
        setTimeout(() => {
            this.props.onSave(); // TODO - this isn't right. Need a better way to update and change at the same time. Probz a new function
        }, 100);
    };

    handleToggleInterval = () => {
        this.setState({
            interval: !this.state.interval
        });
    };

    render() {
        if (this.state.interval) {
            return (
                <span>
                    {this.props.intervals.map((internval, index) => {
                        return (
                            <button
                                key={index}
                                style={{border: 'solid 1px #FFF'}}
                                className="btn btn-secondary filter-box__filter w-100"
                                onClick={this.handleSelectInterval.bind(this, internval.value)}>
                                {internval.label}
                            </button>
                        );
                    })}
                    <button
                        onClick={this.handleToggleInterval}
                        style={{border: 'solid 1px #FFF'}}
                        className="btn btn-secondary filter-box__filter w-100">
                        Custom Date Range
                    </button>
                </span>
            );
        }

        return (
            <div className="container filter-box__filters__date-range" style={{width: '586px'}}>
                <div className="row">
                    <div className="col-sm-6">
                        <h4>
                            Start: {Moment.parseZone(this.state.start).local().format('MM/DD/YYYY')}
                        </h4>
                        <DateTime
                            timeFormat={false}
                            input={false}
                            value={Moment.parseZone(this.state.start).local()}
                            onChange={this.handleChange.bind(this, 'start')}
                        />
                    </div>
                    <div className="col-sm-6">
                        <h4>
                            End: {Moment.parseZone(this.state.end).local().format('MM/DD/YYYY')}
                        </h4>
                        <DateTime
                            timeFormat={false}
                            input={false}
                            value={Moment.parseZone(this.state.end).local()}
                            onChange={this.handleChange.bind(this, 'end')}
                        />
                    </div>
                </div>
                <div className="row pt-2 pb-2">
                    <div className="col-sm-12">
                        <button onClick={this.props.onSave} className="btn btn-primary">
                            Add Filter
                        </button>
                        <button
                            onClick={this.handleToggleInterval}
                            className="btn btn-default tw-ml-3 btn-secondary">
                            Intervals
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
